<script setup lang="ts">
const version = __APP_VERSION__;
</script>

<template>
  <div class="version-display">
    {{ version }}
  </div>
</template>

<style scoped>
.version-display {
  color: var(--text-muted-color);
  font-size: 0.75rem;
}
</style>
